export { default } from './ListTwoTicketStudies';
